export default {
  liveButtonLabel: '',
  playlistButtonLabel: '',
  live: '',
  class: '',
  close: '',
  notShowAgainLabel: '',
};
